<div *ngFor="let item of items;">
  <card-wrap
    (eventClicked)="clickEvent($event)"
    (itemClicked)="clickItem($event)"
    (teamClicked)="clickTeam($event)"
    (webClicked)="clickWeb($event)"
    [item]="item"
  ></card-wrap>
</div>
